export default {

  // INVITATION EMAILS ---------------------------------------------------------------------
  "invitation-clinic-admin": {
    "subject": "My Airway Exam: Invitation to Set up ${facilityName} Admin",
    "paragraphs": [
      "Dear <strong>${name}</strong>,",
      "Welcome to My Airway Exam! We're excited to invite you to join our platform as a clinic administrator for <b>${facilityName}.</b>",
      "Your side of My Airway Exam is designed to streamline the invitation of patients and management of doctors at your facility. A few clicks, and your facility’s day-to-day operations become smoother and more efficient."
    ],
    "buttonText": "Accept Invitation",
    "buttonLink": "https://${hostname}/register?invitationId=${invitationId}",
  },
  "invitation-doctor": {
    "subject": "${clinic} Invitation to Join My Airway Exam",
    "paragraphs": [
      "Dear <b>${name}</b>,",
      "Welcome to <strong>My Airway Exam!</strong> We're excited to invite you to join our platform as a <strong>doctor</strong>.",
      "Our platform allows you to view a screening airway exam before the day of surgery for indicated patients at <b>${facilityName}</b>, making operations smoother and allowing you to plan ahead.",
      "If you provide care at more than one affiliated facility, you will be able to view all exams under one convenient login."
    ],
    "buttonText": "Accept Invitation",
    "buttonLink": "https://${hostname}/register?invitationId=${invitationId}",
  },
  "invitation-patient": {
    "subject": "Your Upcoming Surgery at ${facilityName}: PLEASE COMPLETE ASAP",
    "paragraphs": [
      "Dear <b>${name}</b>,",
      "As part of their commitment to your safety and overall surgical experience, <b>${facilityName}</b> is asking you complete a simple but important evaluation: an online airway examination.",
      "<br><b>What is an airway exam?</b><br>",
      "An airway exam is a quick, non-invasive assessment of the anatomy of your neck, face, and mouth. The goal is to ensure your airway is clear and functioning optimally, which is essential for proper breathing during anesthesia.",
      "<b>What should I expect?</b>",
      "The exam is straightforward, painless, and only takes a few minutes to complete. Oh, and it’s free. You can take the exam with your smartphone at your convenience – no appointments necessary. If you are currently on your computer, <b>please open this email on your smartphone and proceed from there.</b> As always, your answers are 100% private. Please complete as soon as possible, as depending on your responses, you may be contacted for further information."
    ],
    "buttonText": "Take Exam",
    "buttonLink": "https://${hostname}/test/${testId}"
  },

  // PATIENT EMAILS ----------------------------------------------------------------------
   "patient-resubmit-test": {
      "subject": "My Airway Exam: Please Resubmit Your Exam",
      "paragraphs": [
        "Dear <b>${name}</b>,",
        "Thank you for completing your exam. Your anesthesiologist would like you to resubmit your exam. Check the end of the email for more details.",
        "We are terribly sorry for the inconvenience. Please click below to retake."
      ],
      "buttonText": "Retake Exam",
      "buttonLink": "https://${hostname}/test/${testId}",
  },
  "patient-reminder": {
    "subject": "My Airway Exam: Reminder to Complete Your Exam",
    "paragraphs": [
      'Dear ${name},',
      "This is a friendly reminder to complete your My Airway Exam for your upcoming procedure.",
      "It is important that your anesthesiologist has this information as soon as possible. Please click the link below to take the exam.",
      "Remember, if you are currently on your computer, <b>please open this email on your smartphone and proceed from there.</b>"
    ],
    "buttonText": "Take Exam",
    "buttonLink": "https://${hostname}/test/${testId}",
  },

  // CLINIC ADMIN EMAILS ----------------------------------------------------------------------
  "clinic-admin-exam-complete": {
    "subject": "Airway Exam Submitted",
    "paragraphs": [
      "Dear <b>${name}</b>,",
      "Patient <b>${patientLastName}’s, [DOB: ${patientDOB}]</b> has completed their airway exam. If necessary, or it will aid in expedition, please remind an anesthesia provider credentialed at your facility to review the examination.",
    ],
  },
 "clinic-admin-all-good": {
    "subject": "My Airway Exam Complete",
    "paragraphs": [
      "Dear <b>${name}</b>,",
      " Dr. ${doctorName} has reviewed ${patientLastName}, DOB: ${patientDOB}’s airway exam and has determined they are appropriate for surgery. No further action is necessary.",
      "Thank you"
    ],
 },
 "clinic-admin-patient-cant-be-performed": {
   "subject": "My Airway Exam: Recommend Alternative Surgical Facility",
   "paragraphs": [
     "Dear <b>${name}</b>,",
    "<b>Dr. ${doctorName}</b> has found patient <b>${patientLastName}, DOB: ${patientDOB}’s</b> airway exam inappropriate for <b>${facilityName}</b> and recommends a facility with higher levels of care and back up equipment, such as a hospital. For further questions, please contact Dr. <b>${doctorName}</b>.",
    "Thank You So Much"
   ],
  },
  "clinic-admin-in-person-evaluation": {
    "subject": "My Airway Exam: In Person Evaluation Requested",
    "paragraphs": [
      "Dear <b>${name}</b>,",
      "<b>Dr. ${doctorName}</b> found <b>${patientLastName}, DOB: ${patientDOB}’s</b> airway exam to be abnormal and worthy of an in person evaluation prior to surgery. Please contact the patient to arrange.",
      "Thank You So Much"
    ]
  },
  
}